import { money } from "../../lib/api";
import { receivedFor } from "./AdminStats";

const nzKey = (iso) => new Intl.DateTimeFormat("en-CA", { timeZone: "Pacific/Auckland", year: "numeric", month: "2-digit" }).format(new Date(iso)).slice(0, 7);
const label = (key) => new Date(`${key}-15T00:00:00Z`).toLocaleDateString("en-NZ", { month: "short", year: "numeric", timeZone: "UTC" });

const lastMonths = (n) => {
  const [y, m] = nzKey(new Date().toISOString()).split("-").map(Number);
  return Array.from({ length: n }, (_, i) => {
    const d = new Date(Date.UTC(y, m - 1 - (n - 1 - i), 15));
    return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}`;
  });
};

export const MonthlySales = ({ orders }) => {
  const months = lastMonths(6).map((key) => {
    const list = orders.filter((o) => o.created_at && nzKey(o.created_at) === key);
    return {
      key,
      orders: list.filter((o) => o.status !== "cancelled").length,
      received: list.reduce((s, o) => s + receivedFor(o), 0),
    };
  });
  const max = Math.max(1, ...months.map((m) => m.received));

  return (
    <section data-testid="admin-monthly-sales" className="rounded-[24px] chunk bg-white p-5 sm:p-7 mb-8">
      <div className="flex flex-wrap items-end justify-between gap-2">
        <h2 className="font-display font-extrabold text-2xl">Monthly sales</h2>
        <p className="text-sm text-[#5a5470]">Last 6 months · money received by order month</p>
      </div>
      <div className="mt-6 grid grid-cols-6 gap-2 sm:gap-4 items-end h-44" aria-hidden="true">
        {months.map((m) => (
          <div key={m.key} className="h-full flex flex-col justify-end items-center gap-1">
            <span className="font-mono-x text-[11px] sm:text-xs font-bold whitespace-nowrap">{m.received ? `$${Math.round(m.received)}` : ""}</span>
            <div className="w-full max-w-[56px] rounded-t-xl border-2 border-[var(--ink)] bg-[var(--pink)] transition-[height] duration-700"
              style={{ height: `${Math.max(4, (m.received / max) * 100)}%` }} />
          </div>
        ))}
      </div>
      <div className="grid grid-cols-6 gap-2 sm:gap-4 mt-2">
        {months.map((m) => <span key={m.key} className="text-center text-xs font-semibold">{label(m.key).split(" ")[0]}</span>)}
      </div>
      <table className="w-full mt-6 text-sm" data-testid="admin-monthly-table">
        <thead>
          <tr className="text-left text-[#5a5470] border-b-2 border-[var(--ink)]">
            <th className="py-2 font-semibold">Month</th><th className="py-2 font-semibold text-right">Orders</th><th className="py-2 font-semibold text-right">Received</th>
          </tr>
        </thead>
        <tbody>
          {[...months].reverse().map((m) => (
            <tr key={m.key} data-testid={`admin-month-${m.key}`} className="border-b border-dashed border-[var(--ink)]/20">
              <td className="py-2">{label(m.key)}</td>
              <td className="py-2 text-right font-mono-x">{m.orders}</td>
              <td className="py-2 text-right font-mono-x font-bold">{money(m.received)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
};
